import React, { Component } from 'react';
import styles from './index.css';
import {observer} from 'mobx-react';

@observer
export default class Popup extends Component{
    render(){
        let x = Math.floor(this.props.x);
        let y = Math.floor(this.props.y);
        let item = this.props.item;
        return(
            <div className={styles.popupBody} style={{left:x/((window.innerWidth)/120) +'rem',top:y/((window.innerWidth)/120)+'rem'}}>
                {item.name ?  <p style={{fontWeight:'700'}}>{item.name}</p> : null}
                <p>{item.culture === 'None' ?  'Культура: пусто' : 'Культура:' + item.culture}</p>
                <p>{item.groupQuantity ? 'Кількість машин:' + item.groupQuantity : null}</p>
                <p>Вага:{+(item.amount).toFixed(1)}</p>
              <p>Вологість: {+item.moistureLevel.toFixed(2)}%</p>
              <p>Смітніть: {+item.wasteLevel.toFixed(2)}%</p>
                {item.errorStatus ? <p>Помилка: {item.errorStatus}</p> : ''}
            </div>
        )}
}


// WEBPACK FOOTER //
// ./src/shared/components/Game/SubComponents/Popup/index.js